// Data for obtaining user data from Adobe:
export const ADOBE = {
    url: 'https://chegginc.demdex.net/id?d_visid_ver=4.2.0&d_fieldgroup=MC&d_rtbd=json&d_ver=2&d_verify=1&d_orgid=3FE7CBC1556605A77F000101%40AdobeOrg&d_nsid=0&ts=',
    cheggMCIDUrl: 'https://martech-mcid.prod.cheggnet.com/mcid',
    cacheBuster: 'cache_buster',
    cookieName: 'mcid',
    responseIndex: 'mcid',
    timeout: 5000,
};

// Endpoint where analytics will be sent:
export const DESTINATION = {
    // TODO: Replace with prod endpoint when known
    // production: 'https://fn.cheggnet.com/log/log-event-v2-batch',
    // staging: 'https://fn.test.cheggnet.com/log/log-event-v2-batch',
    production: 'https://data.studybreakmedia.com:8899',
    staging: 'https://data.nonprod.studybreakmedia.com:8899',
};

export const AUTH_STATE = {
    hardLoggedIn: 'hard_logged_in',
    softLoggedIn: 'soft_logged_in',
    loggedOut: 'logged_out',
};

export const SUBSCRIPTION_STATUS = {
    active: 'active',
    cancelled: 'cancelled',
    nonMember: 'non_member',
    paused: 'paused',
};

// Prefixed to all logs and error events
export const LOGGING_NAMESPACE = 'analytics-frontend';

// Milliseconds for which events will be throttled, for the purpose of bulk sends:
export const THROTTLE_RATE = 200;

// Time until error is sent for slow/no AF init:
export const INIT_TIMEOUT_THRESHOLD = 7000;

// Time until error is sent for slow request to server
export const SLOW_RESPONSE_THRESHOLD = 5000;

// Amount of time before the first failed request to the backend is retried.
// Will be doubled with each retry, until the REQUEST_RETRIES limit is reached.
export const INITIAL_DELAY_BETWEEN_RETRIES = 100;

// Max attempts to reach backend before abort/error.
export const REQUEST_RETRIES = 11;

// A list of acceptable device platforms on which events occur:
export const PLATFORM_WHITELIST = [
    'tablet',
    'mobile',
    'desktop',
    'tv',
    'bot',
    undefined,
];

// Map of AF event types and their corresponding chegg-event-spec specs:
export const EVENTS = {
    pageview: {
        cheggDbEventName: 'page_view',
        version: '5.0.0',
    },
    cardEngagement: {
        cheggDbEventName: 'card_engagement',
        version: '4.0.0',
    },
    citationCreated: {
        cheggDbEventName: 'citation_created',
        version: '3.0.0',
    },
    paperUpload: {
        cheggDbEventName: 'paper_upload',
        version: '4.0.0',
    },
    transaction: {
        cheggDbEventName: 'transaction',
        version: '4.0.0',
    },
    slotRender: {
        cheggDbEventName: 'slot_render',
        version: '1.0.0',
    },
    videoEvent: {
        cheggDbEventName: 'video_event',
        version: '1.0.0',
    },
};
